import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';

import './Input.scss';

export interface InputProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  hasError?: boolean;
  active?: boolean;
}

const Input = ({ className, hasError, active, ...props }: InputProps, ref) => (
  <input
    className={classnames(
      'input',
      { input_error: hasError, input_active: active },
      className,
    )}
    ref={ref}
    {...props}
  />
);

export default React.forwardRef(Input);
